export default __webpack_public_path__ + "static/media/proj3.a4af76e4.png";